




























































import { computed, defineComponent, ref } from "@vue/composition-api";
import "@/components/icons";
import Overlay from "@/components/Atoms/Overlay/index.vue";
import FloatingView from "@/components/Atoms/FloatingView/index.vue";
import Heading from "@/components/Atoms/Typography/Heading/index.vue";
import OccRadio from "@/components/Atoms/OccRadio/index.vue";
import Button from "@/components/Atoms/Button/index.vue";
import ButtonConfig from "@/components/Molecules/ButtonConfig/index.vue";
import Caption from "@/components/Atoms/Typography/Caption/index.vue";
import {
  lotteryTransitionPossibleEventStatuses,
  unlotteryTransitionPossibleEventStatuses
} from "@/helpers/eventEntryUsers";

export default defineComponent({
  name: "UpdateEventStatusFloatingView",
  components: {
    Overlay,
    FloatingView,
    Heading,
    OccRadio,
    Button,
    ButtonConfig,
    Caption
  },
  props: {
    total: {
      type: Number,
      required: true
    },
    lottery: {
      type: Boolean,
      required: true
    }
  },
  emits: ["cancel", "next"],
  setup(props, { emit }) {
    const selectedEventStatus = ref("");

    const handleClickCancel = () => {
      emit("cancel");
    };
    const handleClickNext = () => {
      emit("next", selectedEventStatus.value);
    };

    const onChange = (selectedStatus: string) => {
      selectedEventStatus.value = selectedStatus;
    };
    const isChecked = (selectedStatus: string) => {
      return selectedEventStatus.value === selectedStatus;
    };

    const transitionPossibleEventStatuses = computed(() => {
      return props.lottery
        ? lotteryTransitionPossibleEventStatuses
        : unlotteryTransitionPossibleEventStatuses;
    });

    return {
      selectedEventStatus,

      transitionPossibleEventStatuses,
      onChange,
      isChecked,

      handleClickCancel,
      handleClickNext
    };
  }
});
